import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';

@Component({
  selector: 'app-aicontent-detector-features',
  templateUrl: './aicontent-detector-features.component.html',
  styleUrls: ['./aicontent-detector-features.component.scss']
})
export class AIContentDetectorFeaturesComponent implements OnInit {

  constructor(
      private titleService: Title,
      private metaTagService: Meta,
      private LinkService: LinkService
    ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Trinka 的 AI 內容檢測工具 — 快速識別 AI 生成文字');
    this.metaTagService.updateTag({ name: 'description', content: '有效辨識來自 ChatGPT、Gemini、Perplexity、Bing Copilot 等生成式 AI 工具所產出的內容，協助您確保文稿的真實性與原創性。' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka 的 AI 內容檢測工具 — 快速識別 AI 生成文字' });
    this.metaTagService.updateTag({ property: 'og:description', content: '有效辨識來自 ChatGPT、Gemini、Perplexity、Bing Copilot 等生成式 AI 工具所產出的內容，協助您確保文稿的真實性與原創性。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features/ai-content-detector' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka 的 AI 內容檢測工具 — 快速識別 AI 生成文字' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "有效辨識來自 ChatGPT、Gemini、Perplexity、Bing Copilot 等生成式 AI 工具所產出的內容，協助您確保文稿的真實性與原創性。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/ai-content-detector' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/ai-content-detector' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/ai-content-detector' });

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }

}
